import './public-path';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.scss';
import { AppModule } from './app/app.module';
import { AppComponent } from './app/app.component';

const root = ReactDOM.createRoot(
  document.getElementById('app-root') as HTMLElement
);
root.render(
  <AppModule>
    <AppComponent />
  </AppModule>
);
